<template>
<div class="form row">
   <div class="col-md-12 " >
       <p style="padding:3px;background: lightgrey;height: 30px;font-size: medium" >Grupa towarów {{groupName}}</p>
   </div>
    <div v-for="(item, index) in group" :key="index" class="col-md-12 m-b-sm">
        <div class="row">
            <div class="col max-w-120">
                <InputWrapper
                    :disabled="true"
                    :label="__('symbol') + '*'"
                    :value="item.standard_item.symbol"
                    classNames="form-control"
                    type="text"
                />
            </div>
            <div class="col">
                <InputWrapper
                    :disabled="true"
                    :label="__('item_name') + '*'"
                    :value="item.standard_item.item_name"
                    classNames="form-control"
                    type="text"
                />
            </div>
            <div class="col" style="margin: auto;max-width: 20px;">
                <i class="fas fa-info "  data-toggle="tooltip" data-placement="top" :title="__('additional_information_goods_service')"></i>
            </div>
            <div class="col max-w-80">
                <InputWrapper
                    :disabled="false"
                    :label="__('item_quantity') + '*'"
                    value="0,00"
                    classNames="form-control"
                    type="text"
                />
            </div>
            <div class="col max-w-120">
                <InputWrapper
                    :labelClass="'white-space-no-wrap'"
                    :disabled="false"
                    :label="'Wartość jedn. w XXX'"
                    value="0,00"
                    classNames="form-control w-120"
                    type="text"
                />
            </div>
            <div class="col max-w-120">
                <InputWrapper
                    :disabled="true"
                    :label="__('value') + '*'"
                    value=""
                    classNames="form-control"
                    type="text"
                />
            </div>
        </div>


    </div>
</div>
</template>

<script>
import InputWrapper from "../form/InputWrapper";
export default {
    name: "GroupItems",
    components: { InputWrapper},
    props:{
        group:{
            type: Array,
            required:true,
        },
        groupName:{
            type:String,
            required:true,
        }
    }
}
</script>

<style scoped>

</style>
